import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Spinner,
} from "reactstrap";

const durationOptions = [
  { label: "3 Months", value: 3 },
  { label: "6 Months", value: 6 },
  { label: "12 Months", value: 12 },
  { label: "24 Months", value: 24 },
];

const initialForm = {
  Member_Name: "",
  Mobile_Number: "",
  Email_Address: "",
  Address_with_Location: "",
  Membership_Plan: "",
  Membership_Activation_Date: "",
  Membership_Expiry_Date: "",
  Door_Delivery: "No",
  Deposit_Paid: "",
  Amount_Paid: "",
};

const MemberForm = ({ onSubmit, editData, postData, saving, planExpired }) => {
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (editData || postData) {
      setFormData({ ...editData, ...postData });
    }
    console.log("Form data initialized:", { editData, postData });
  }, [editData, postData]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      createdAt: editData?.createdAt || new Date().toISOString(),
      createdBy: editData?.createdBy || "admin",
    };
    onSubmit(payload);
  };

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);

    // Fix for month overflow (e.g. Jan 31 + 1 month → Mar 3)
    if (result.getDate() !== date.getDate()) {
      result.setDate(0); // set to last day of previous month
    }

    return result;
  };

  const handleDurationChange = (e) => {
    const months = parseInt(e.target.value, 10);
    const today = new Date();
    const expiryDate = addMonths(today, months);

    setFormData({
      ...formData,

      Membership_Last_Renewal_Date: formatDate(today),
      Membership_Expiry_Date: formatDate(expiryDate),
      Membership_Duration: months,
    });
  };
  
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        {!planExpired && (
          <div>
            <Col md={6}>
              <FormGroup>
                <Label for="Member_Name">Name</Label>
                <Input
                  type="text"
                  name="Member_Name"
                  value={formData.Member_Name}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="Mobile_Number">Mobile Number</Label>
                <Input
                  type="text"
                  name="Mobile_Number"
                  value={formData.Mobile_Number}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="Email_Address">Email</Label>
                <Input
                  type="email"
                  name="Email_Address"
                  value={formData.Email_Address}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <Label for="Address_with_Location">Address</Label>
                <Input
                  type="text"
                  name="Address_with_Location"
                  value={formData.Address_with_Location}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </div>
        )}
        <Col md={4}>
          <FormGroup>
            <Label for="Membership_Plan">Membership Plan</Label>
            <Input
              type="select"
              name="Membership_Plan"
              id="Membership_Plan"
              value={formData.Membership_Plan}
              onChange={handleChange}
            >
              <option value="">Select a plan</option>
              <option value="2 Books">2 Books</option>
              <option value="3 Books">3 Books</option>
              <option value="4 Books">4 Books</option>
               <option value="6 Books">6 Books</option>
                <option value="8 Books">8 Books</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md={4}>
          <FormGroup>
            <Label for="Membership_Duration">Membership Duration</Label>
            <Input
              type="select"
              name="Membership_Duration"
              value={formData.Membership_Duration || ""}
              onChange={handleDurationChange}
            >
              <option value="">Select Duration</option>
              {durationOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>

        <Col md={4}>
          <FormGroup>
            <Label for="Membership_Last_Renewal_Date">Last Renewal Date</Label>
            <Input
              type="date"
              name="Membership_Last_Renewal_Date"
              value={formData.Membership_Last_Renewal_Date || ""}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>

        <Col md={4}>
          <FormGroup>
            <Label for="Membership_Expiry_Date">Expiry Date</Label>
            <Input
              type="date"
              name="Membership_Expiry_Date"
              value={formData.Membership_Expiry_Date || ""}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>

        <Col md={4}>
          <FormGroup>
            <Label for="Door_Delivery">Door Delivery</Label>
            <Input
              type="select"
              name="Door_Delivery"
              value={formData.Door_Delivery}
              onChange={handleChange}
            >
              <option>No</option>
              <option>Yes</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md={6}>
          {planExpired ? (
            <FormGroup>
              <Label for="Amount_Paid">Amount Paid</Label>
              <Input
                type="text"
                name="Amount_Paid"
                value={formData.Amount_Paid}
                onChange={handleChange}
                placeholder="e.g., 750 /-"
              />
            </FormGroup>
          ) : (
            <FormGroup>
              <Label for="Deposit_Paid">Deposit Paid</Label>
              <Input
                type="text"
                name="Deposit_Paid"
                value={formData.Deposit_Paid}
                onChange={handleChange}
                placeholder="e.g., 750 /-"
              />
            </FormGroup>
          )}
        </Col>
         <Col md={6}>
          <FormGroup>
            <Label for="Remarks">Remarks</Label>
            <Input
              type="textarea"
              name="Remarks"
              value={formData.Remarks}
              onChange={handleChange}
            />
             
          </FormGroup>
        </Col>
      </Row>
<Row>
        <Col md={2}>
          <FormGroup>
            <Label for="Additional_Notes">Additional Books</Label>
            <Input
              type="Number"
              name="Additional_Books"
              value={formData.Additional_Books}
              onChange={handleChange}
             onWheel={(e) => e.target.blur()}
            />
          </FormGroup>
        </Col>
         <Col md={3}>
          <FormGroup>
            <Label for="Offer Activation Date">Offer Activation Date</Label>
            <Input
              type="date"
              name="Offer_Activation_Date"
              value={formData.Offer_Activation_Date || ""}
              onChange={handleChange}
             
            />
          </FormGroup>
        </Col>
         <Col md={3}>
          <FormGroup>
            <Label for="Offer Validity">Offer Validity (Months)</Label>
            <Input
              type="Number"
              name="Offer_Validity"
              value={formData.Offer_Validitiy}
              onChange={handleChange}
              onWheel={(e) => e.target.blur()}
            />
          </FormGroup>
        </Col>
      </Row>
      {saving ? (
        <Spinner>
          <span>Loading...</span>
        </Spinner>
      ) : (
        <Button color="primary" type="submit">
          {editData ? "Update Member" : "Submit"}
        </Button>
      )}
    </Form>
  );
};

export default MemberForm;
